import { reactive } from 'vue'

const useModal = (obj) => {
  const modal = reactive(obj)
  const modalClose = (val) => {
    if (modal[val]) {
      modal[val] = false
    } else {
      Object.keys(modal).forEach((key) => {
        modal[key] = false
      })
    }
    return {}
  }
  return { modal, modalClose }
}
export default useModal
